function localquery(query) {
    return query
}

export default localquery